import {
  Badge,
  Button,
  Divider,
  Flex,
  Icon,
  Space,
  ThemeColorModes,
  useColorMode,
  useColorStyle,
} from '@tonic-one/react';
import { MoonIcon, SunIcon } from '@tonic-one/react-icons';
import React from 'react';
import config from 'src/config';

import AccountSetting from './AccountSetting';
import NotificationAndTask from './NotificationAndTask';
import BreadCrumb from './BreadCrumb';
import TimeZone from './TimeZone';
import { useTranslation } from 'react-i18next';
import { useTextButtonStyle } from '@Components/CasHeader/style';
import { isDefaultUI, isInUIC } from '@Utils/common';
import { Layout } from 'antd';
import { MultiTenantsProvider } from '@Models/useMultiTenant';
import { usePermissionStore } from '@Models/usePermissionModel';

const CasHeader = () => {
  const [colorMode, setColorMode] = useColorMode();
  const toggleColorMode = () => {
    const colorModeMap: Record<ThemeColorModes, ThemeColorModes> = {
      dark: 'light',
      light: 'dark',
    };
    setColorMode(colorModeMap[colorMode]);
  };

  const [colorStyle] = useColorStyle({ colorMode });
  const { t } = useTranslation();
  const textButtonStyle = useTextButtonStyle();
  const { managementScopeIds } = usePermissionStore();
  function redirectToCasConsole() {
    if (isDefaultUI()) {
      window.open(config.ui.classicUrl, '_blank');
    } else {
      window.open('/', '_blank');
    }
  }

  if (isInUIC()) {
    return <></>;
  }
  return (
    <Layout.Header style={{ height: '48px', padding: 0 }}>
      <Flex
        height="100%"
        pl="16px"
        align="center"
        justify="space-between"
        color={colorStyle.color.primary}
        background={
          colorMode === 'dark'
            ? colorStyle.background.secondary
            : colorStyle.background.primary
        }
        borderBottom={colorMode === 'dark' ? '' : '1px solid'}
        borderColor={colorMode === 'dark' ? '' : colorStyle.background.tertiary}
      >
        <BreadCrumb />
        <Flex align="center" height="100%">
          {managementScopeIds === 'all' &&
            ['dev_wu'].includes(config.ui.siteName) && (
              <Button
                variant="ghost"
                data-track="CasHeader.AccountSetting.adminConsole"
                onClick={redirectToCasConsole}
                mr={9}
              >
                <ConsoleSvg />
                <Space width="2x" />
                {t('header.account.classicConsole.btn')}
              </Button>
            )}
          <Divider
            variant="solid"
            orientation="vertical"
            height="48px"
            borderColor={colorStyle.background.primary}
          />
          <TimeZone />
          <Divider
            variant="solid"
            orientation="vertical"
            height="48px"
            borderColor={colorStyle.background.primary}
          />
          {(!config.ui.hideFeature.header.colorSwitch ||
            config.ui.deployEnv === 'stg') && (
            <Flex
              align="center"
              cursor="pointer"
              {...textButtonStyle}
              onClick={() => {
                toggleColorMode();
                localStorage.setItem(
                  'isBlackMode',
                  colorMode === 'dark' ? 'false' : 'true'
                );
              }}
            >
              <Badge alignItems="center">
                {colorMode === 'dark' ? (
                  <Icon as={SunIcon} size={16} m="16px 16px" />
                ) : (
                  <Icon as={MoonIcon} size={16} m="16px 16px" />
                )}
              </Badge>
            </Flex>
          )}
          <Divider
            variant="solid"
            orientation="vertical"
            height="48px"
            borderColor={colorStyle.background.primary}
          />
          <NotificationAndTask />
          <Divider
            variant="solid"
            orientation="vertical"
            height="48px"
            borderColor={colorStyle.background.primary}
          />
          {/*{!config.ui.hideFeature.header.accountSwitch && (*/}
          {/*  <Flex align="center" height="100%">*/}
          {/*    <AccountSwitch setLoading={setLoading} />*/}
          {/*    <Divider*/}
          {/*      variant="solid"*/}
          {/*      orientation="vertical"*/}
          {/*      height="48px"*/}
          {/*      borderColor={colorStyle.background.primary}*/}
          {/*    />*/}
          {/*  </Flex>*/}
          {/*)}*/}
          <MultiTenantsProvider>
            <AccountSetting />
          </MultiTenantsProvider>
        </Flex>
      </Flex>
    </Layout.Header>
  );
};
export default CasHeader;

const ConsoleSvg = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M5 2H13C13.5523 2 14 2.44772 14 3V12" stroke="currentColor" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 9H1V14C1 14.5523 1.44772 15 2 15H10C10.5523 15 11 14.5523 11 14V9ZM0 9V6C0 4.89543 0.895431 4 2 4H10C11.1046 4 12 4.89543 12 6V9V14C12 15.1046 11.1046 16 10 16H2C0.895431 16 0 15.1046 0 14V9Z"
        fill="currentColor"
      />
      <rect x="3" y="6" width="3" height="1" rx="0.5" fill="currentColor" />
      <rect x="1" y="6" width="1" height="1" rx="0.5" fill="currentColor" />
    </svg>
  );
};
